"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMetadataObject = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
/* eslint-disable @typescript-eslint/no-empty-interface, import/namespace */
var m = tslib_1.__importStar(require("@gooddata/sdk-model"));
/**
 * Type guard checking whether input is an instance of {@link IMetadataObject}.
 * @deprecated Use {@link @gooddata/sdk-model#isMetadataObject}
 * @public
 */
exports.isMetadataObject = m.isMetadataObject;
//# sourceMappingURL=types.js.map